import { memo, useMemo } from 'react';
import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useFindOneProductTemplate } from 'modules/inventory/settings/product-templates/hooks/useFindOneProductTemplate';
import { sortByOrder } from 'modules/inventory/settings/product-templates/utils/product-template.utils';
import ProductTemplatePreview from 'modules/inventory/settings/product-templates/components/ProductTemplatePreview/ProductTemplatePreview';

type ProductTemplatePreviewDialogProps = {
  open: boolean;
  templateId: string | null;
  onClose: () => void;
};

const ProductTemplatePreviewDialog = ({ open, templateId, onClose }: ProductTemplatePreviewDialogProps) => {
  const { t } = useTranslation('productTemplates');
  const { data: template } = useFindOneProductTemplate(open ? templateId : null);

  const fields = useMemo(() => (template ? sortByOrder(template).fields : []), [template]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='sm'>
      <DialogContent>
        <ProductTemplatePreview bordered={false} name={template?.name} fields={fields} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common:close')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default memo(ProductTemplatePreviewDialog);
